import { Component } from "react";
import { formatDate } from "../../common/services/utilities";
import ThemeableAgGrid from "../../common/components/agGrid/ThemeableAgGrid";
import { withTranslation } from "react-i18next";

class BCEnvironmentalIssuancesTable extends Component {
  getColumnDefs() {
    return [
      {
        field: "IssueDate",
        headerName: this.props.t("IssueDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "AccountName",
        headerName: this.props.t("AccountName"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "ProjectName",
        headerName: this.props.t("ProjectName"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Location",
        headerName: this.props.t("Location"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Quantity",
        headerName: this.props.t("Quantity"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "StandardName",
        headerName: this.props.t("StandardName"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "Vintage",
        headerName: this.props.t("Vintage"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "ProjectType",
        headerName: this.props.t("ProjectType"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "PeriodStartDate",
        headerName: this.props.t("PeriodStartDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "PeriodEndDate",
        headerName: this.props.t("PeriodEndDate"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "VerifierCompany",
        headerName: this.props.t("VerifierCompany"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "SerialNo",
        headerName: this.props.t("SerialNo"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "UnitType",
        headerName: this.props.t("UnitType"),
        filter: false,
        floatingFilter: false,
      },
      {
        field: "UnitMeasurementName",
        headerName: this.props.t("UnitMeasurementName"),
        filter: false,
        floatingFilter: false,
      },
    ];
  }

  mapToViewModel(records) {
    return records.map((record, index) => ({
      index,
      IssueDate: formatDate(record.issueDate),
      AccountName: record.accountName,
      ProjectName: record.projectName,
      Location: record.location,
      Quantity: record.holdingQuantity,
      StandardName: record.standardName,
      Vintage: record.vintage,
      ProjectType: record.projectType,
      PeriodStartDate: formatDate(record.periodStartDate),
      PeriodEndDate: formatDate(record.periodEndDate),
      VerifierCompany: record.verifierName,
      SerialNo: record.serialNo,
      UnitType: record.unitType,
      UnitMeasurementName: record.unitMeasurementName,
    }));
  }

  render() {
    const { records } = this.props;
    const rowData = this.mapToViewModel(records);
    const columnDefs = this.getColumnDefs();

    return (
      <ThemeableAgGrid
        className="table-extra-small"
        columnDefs={columnDefs}
        rowData={rowData}
        getRowId={(params) => String(params.data.index)}
        pagination={true}
        paginationPageSize={20}
        paginationPageSizeSelector={[5, 10, 20, 50, 100]}
        suppressPaginationPanel={false}
        allowHorizontalScroll={true}
      />
    );
  }
}

export default withTranslation(["marketdata"])(BCEnvironmentalIssuancesTable);
